// extracted by mini-css-extract-plugin
module.exports = {"about-us":"sustainablity_about-us__37pC6","subHeader":"sustainablity_subHeader__3DJjI","detail":"sustainablity_detail__3GxE-"};